(function () {
  var REQUEST_TIMEOUT_MS = 20000;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function parseRedirectUrl(result) {
    var candidate = null;

    if (Array.isArray(result) && result[0] && result[0].body) {
      candidate = result[0].body;
    } else if (result && result.checkout_url) {
      candidate = result.checkout_url;
    } else if (result && result.body) {
      candidate = result.body;
    }

    if (typeof candidate !== 'string') return null;

    try {
      var url = new URL(candidate);
      return url.protocol === 'https:' ? url.href : null;
    } catch (error) {
      return null;
    }
  }

  function debugEnabled(element) {
    return element && element.dataset.debugEnabled === 'true';
  }

  function logDiagnostic(enabled, context, details) {
    if (!enabled) return;
    console.info('[membership] ' + context, details);
  }

  function assertApplicationSuccess(result, context) {
    var envelope = Array.isArray(result) ? result[0] : result;
    var hasExplicitError =
      envelope &&
      typeof envelope === 'object' &&
      (envelope.success === false || envelope.ok === false || Boolean(envelope.error));

    if (hasExplicitError) {
      throw new Error(context + ' was rejected by the service.');
    }

    return result;
  }

  function logFailure(debug, context, endpoint, payload, error) {
    if (debug) {
      console.error('[membership] ' + context + ' failed', {
        endpoint: endpoint,
        payloadKeys: Object.keys(payload || {}),
        error: error,
      });
      return;
    }

    console.error('[membership] ' + context + ' failed', error);
  }

  function postJson(endpoint, payload, context, debug) {
    var controller = new AbortController();
    var timeoutId = window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT_MS);

    logDiagnostic(debug, context + ' request', {
      endpoint: endpoint,
      payloadKeys: Object.keys(payload || {}),
    });

    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller.signal,
    }).then(function (response) {
      logDiagnostic(debug, context + ' response', {
        status: response.status,
        ok: response.ok,
      });

      if (!response.ok) {
        var error = new Error('HTTP ' + response.status);
        error.status = response.status;
        throw error;
      }

      return response
        .json()
        .catch(function (error) {
          error.message = 'Invalid JSON response from ' + context + ': ' + error.message;
          throw error;
        })
        .then(function (result) {
          return assertApplicationSuccess(result, context);
        });
    }).finally(function () {
      window.clearTimeout(timeoutId);
    });
  }

  function setMessage(container, text, isError) {
    if (!container) return;
    container.textContent = text || '';
    container.hidden = !text;
    container.classList.add('form__message');
    container.classList.toggle('membership-message--error', Boolean(isError));
    container.setAttribute('role', isError ? 'alert' : 'status');
  }

  function setButtonLoading(button, loading, loadingText) {
    if (!button) return;
    if (!button.dataset.originalText) button.dataset.originalText = button.textContent.trim();
    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    button.textContent = loading ? loadingText || button.dataset.originalText : button.dataset.originalText;
  }

  function getNamedValue(form, name) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) return '';
    if (input.type === 'checkbox') return input.checked ? input.value || 'true' : '';
    return input.value || '';
  }

  function actionPayload(form) {
    var actionType = form.dataset.actionType || 'mandate';

    if (actionType === 'cancel') {
      return {
        subscription_id: getNamedValue(form, 'subscription_id'),
        customer_id: getNamedValue(form, 'customer_id'),
        email: getNamedValue(form, 'email'),
        name: getNamedValue(form, 'name'),
      };
    }

    return {
      shopifyCustomerId: getNamedValue(form, 'shopifyCustomerId'),
      amount: Number(getNamedValue(form, 'amount') || 0),
      email: getNamedValue(form, 'email'),
      name: getNamedValue(form, 'name'),
    };
  }

  function checkoutPayload(form) {
    return {
      email: getNamedValue(form, 'email'),
      phone: getNamedValue(form, 'phone'),
      company: getNamedValue(form, 'company'),
      firstName: getNamedValue(form, 'firstName'),
      lastName: getNamedValue(form, 'lastName'),
      street: getNamedValue(form, 'street'),
      houseNumber: getNamedValue(form, 'houseNumber'),
      postalCode: getNamedValue(form, 'postalCode'),
      city: getNamedValue(form, 'city'),
      country: getNamedValue(form, 'country'),
      terms: getNamedValue(form, 'terms'),
      baseAmount: getNamedValue(form, 'baseAmount'),
      vatAmount: getNamedValue(form, 'vatAmount'),
      totalAmount: getNamedValue(form, 'totalAmount'),
      shopifyCustomerId: getNamedValue(form, 'shopifyCustomerId'),
      variantId: getNamedValue(form, 'variantId'),
      totalPrice: getNamedValue(form, 'totalPrice'),
    };
  }

  function initLoginReturnLinks() {
    document.querySelectorAll('[data-membership-login-return]').forEach(function (link) {
      var baseUrl = link.dataset.loginUrl || link.getAttribute('href') || '/account/login';
      try {
        var url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('return_url', window.location.pathname + window.location.search);
        link.href = url.pathname + url.search + url.hash;
      } catch (error) {
        return;
      }
    });
  }

  function initActionForms() {
    document.querySelectorAll('[data-membership-action-form]').forEach(function (form) {
      if (form.dataset.membershipBound === 'true') return;
      form.dataset.membershipBound = 'true';
      var isSubmitting = false;
      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = false;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (isSubmitting) return;

        var endpoint = form.dataset.endpoint;
        var status = form.querySelector('[data-membership-action-status]');
        var context = form.dataset.actionContext || 'membership action';
        var payload = actionPayload(form);
        var debug = debugEnabled(form);

        if (!endpoint) {
          setMessage(status, form.dataset.unconfiguredMessage, true);
          return;
        }

        isSubmitting = true;
        setMessage(status, '', false);
        setButtonLoading(button, true, form.dataset.loadingText);

        postJson(endpoint, payload, context, debug)
          .then(function (result) {
            var redirectUrl = parseRedirectUrl(result);
            logDiagnostic(debug, context + ' parsed redirect', { redirectUrl: redirectUrl });

            if (redirectUrl) {
              window.location.href = redirectUrl;
              return;
            }

            if (form.dataset.reloadOnSuccess === 'true') {
              setMessage(status, form.dataset.successMessage, false);
              window.setTimeout(function () {
                window.location.reload();
              }, 900);
              return;
            }

            throw new Error('No valid redirect URL returned from ' + context);
          })
          .catch(function (error) {
            isSubmitting = false;
            setButtonLoading(button, false);
            logFailure(debug, context, endpoint, payload, error);
            setMessage(status, form.dataset.errorMessage, true);
          });
      });
    });
  }

  function initMembershipModals() {
    document.querySelectorAll('[data-membership-modal-trigger]').forEach(function (trigger) {
      if (trigger.dataset.membershipModalBound === 'true') return;
      trigger.dataset.membershipModalBound = 'true';

      var modalId = trigger.getAttribute('aria-controls');
      var modal = modalId ? document.getElementById(modalId) : null;
      if (!modal) return;

      var closeButtons = modal.querySelectorAll('[data-membership-modal-close]');
      var firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

      function openModal() {
        modal.hidden = false;
        document.documentElement.classList.add('membership-modal-open');
        window.setTimeout(function () {
          if (typeof trapFocus === 'function' && firstFocusable) {
            trapFocus(modal, firstFocusable);
          } else if (firstFocusable) {
            firstFocusable.focus();
          }
        }, 0);
      }

      function closeModal() {
        modal.hidden = true;
        document.documentElement.classList.remove('membership-modal-open');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(trigger);
        } else {
          trigger.focus();
        }
      }

      trigger.addEventListener('click', openModal);

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeModal();
      });
    });
  }

  function initDetailsToggles() {
    document.querySelectorAll('[data-membership-details-toggle]').forEach(function (button) {
      if (button.dataset.membershipDetailsBound === 'true') return;
      button.dataset.membershipDetailsBound = 'true';

      var detailsId = button.getAttribute('aria-controls');
      var details = detailsId ? document.getElementById(detailsId) : null;
      if (!details) return;

      function update(open) {
        details.hidden = !open;
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        button.textContent = open ? button.dataset.hideLabel : button.dataset.showLabel;
      }

      update(button.getAttribute('aria-expanded') === 'true');

      button.addEventListener('click', function () {
        update(button.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function initMembershipCheckoutForms() {
    document.querySelectorAll('[data-membership-checkout-form]').forEach(function (form) {
      if (form.dataset.membershipBound === 'true') return;
      form.dataset.membershipBound = 'true';

      var section = form.closest('[data-membership-checkout-section]');
      var params = new URLSearchParams(window.location.search);
      var requestedProductId = params.get('productId') || '';
      var configuredProductId = form.dataset.configuredProductId || '';
      var variantId = params.get('variantId') || params.get('variant') || form.dataset.defaultVariantId || '';
      var basePrice = Number(form.dataset.basePrice || 0);
      var vatRate = Number(form.dataset.vatRate || 0) / 100;
      var vatCountry = form.dataset.vatCountry || '';
      var productDataEl = section ? section.querySelector('[data-membership-product-json]') : null;
      var productData = null;
      var isSubmitting = false;
      var button = form.querySelector('[type="submit"]');

      try {
        productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;
      } catch (error) {
        productData = null;
      }

      function findVariant(id) {
        if (!productData || !Array.isArray(productData.variants) || !id) return null;
        return productData.variants.find(function (variant) {
          return String(variant.id) === String(id);
        });
      }

      function formatMoney(amount) {
        return (form.dataset.currencyCode || 'EUR') + ' ' + Number(amount || 0).toFixed(2).replace('.', ',');
      }

      function setInput(name, value) {
        var input = form.querySelector('[name="' + name + '"]');
        if (input) input.value = value;
      }

      function setText(selector, text) {
        document.querySelectorAll(selector).forEach(function (element) {
          element.textContent = text;
        });
      }

      function statusElement() {
        return form.querySelector('[data-membership-checkout-status]');
      }

      function validateProductContext(showMessage) {
        var message = '';
        var selectedVariant = findVariant(variantId);

        if (configuredProductId && String(requestedProductId) !== String(configuredProductId)) {
          message = requestedProductId ? form.dataset.invalidProductMessage : form.dataset.missingProductMessage;
        } else if (!selectedVariant || selectedVariant.available !== true) {
          message = form.dataset.invalidVariantMessage;
        }

        if (showMessage) setMessage(statusElement(), message, Boolean(message));
        return !message;
      }

      function updateBillingDate() {
        var date = new Date();
        setText('[data-membership-billing-date]', date.toLocaleDateString(form.dataset.locale || undefined, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }));
      }

      function updateTotals() {
        var selectedVariant = findVariant(variantId);
        if (selectedVariant && typeof selectedVariant.price === 'number') {
          basePrice = selectedVariant.price / 100;
        }

        var countryInput = form.querySelector('[name="country"]');
        var country = countryInput ? countryInput.value : '';
        var vat = country === vatCountry ? basePrice * vatRate : 0;
        var total = basePrice + vat;

        setInput('baseAmount', basePrice.toFixed(2));
        setInput('vatAmount', vat.toFixed(2));
        setInput('totalAmount', total.toFixed(2));
        setInput('variantId', variantId);
        setInput('totalPrice', total.toFixed(2));

        setText('[data-membership-subtotal]', formatMoney(basePrice));
        setText('[data-membership-vat]', formatMoney(vat));
        setText('[data-membership-total]', formatMoney(total));

        document.querySelectorAll('[data-membership-vat-line]').forEach(function (element) {
          var shouldShowVat = vat > 0;
          element.hidden = !shouldShowVat;
          element.style.display = shouldShowVat ? 'flex' : 'none';
        });
      }

      function setError(input, message) {
        var error = form.querySelector('[data-error-for="' + input.name + '"]');
        input.classList.toggle('field-error', Boolean(message));
        input.setAttribute('aria-invalid', message ? 'true' : 'false');
        if (error) {
          error.textContent = message || '';
          error.hidden = !message;
        }
      }

      function validate() {
        var isValid = true;

        form.querySelectorAll('[data-required]').forEach(function (input) {
          var message = '';

          if (input.type === 'checkbox' && !input.checked) {
            message = input.dataset.errorMessage || '';
          } else if (input.type !== 'checkbox' && !String(input.value || '').trim()) {
            message = input.dataset.errorMessage || '';
          } else if (input.type === 'email' && input.value && !input.checkValidity()) {
            message = input.dataset.emailErrorMessage || input.dataset.errorMessage || '';
          }

          setError(input, message);
          if (message) isValid = false;
        });

        return isValid;
      }

      updateBillingDate();
      updateTotals();
      validateProductContext(true);
      if (button) button.disabled = false;

      var countrySelect = form.querySelector('[name="country"]');
      if (countrySelect) countrySelect.addEventListener('change', updateTotals);

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (isSubmitting) return;

        var endpoint = form.dataset.checkoutEndpoint;
        var status = statusElement();
        var debug = debugEnabled(form);

        if (!endpoint) {
          setMessage(status, form.dataset.unconfiguredMessage, true);
          return;
        }

        updateTotals();

        if (!validateProductContext(true) || !validate()) return;

        isSubmitting = true;
        setMessage(status, '', false);
        setButtonLoading(button, true, form.dataset.loadingText);

        var payload = checkoutPayload(form);

        postJson(endpoint, payload, 'member checkout', debug)
          .then(function (result) {
            var redirectUrl = parseRedirectUrl(result);
            logDiagnostic(debug, 'member checkout parsed redirect', { redirectUrl: redirectUrl });
            if (!redirectUrl) throw new Error('No valid checkout URL returned from member checkout');
            window.location.href = redirectUrl;
          })
          .catch(function (error) {
            isSubmitting = false;
            setButtonLoading(button, false);
            logFailure(debug, 'member checkout', endpoint, payload, error);
            setMessage(status, form.dataset.errorMessage, true);
          });
      });
    });
  }

  function setMembershipCtaDisabled(link, disabled) {
    if (disabled) {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      return;
    }

    link.removeAttribute('aria-disabled');
    link.removeAttribute('tabindex');
  }

  function forEachMembershipCta(sectionId, callback) {
    document.querySelectorAll('[data-membership-cta-link]').forEach(function (link) {
      if (sectionId && String(link.dataset.sectionId) !== String(sectionId)) return;
      callback(link);
    });
  }

  function disableMembershipCtas(sectionId) {
    forEachMembershipCta(sectionId, function (link) {
      setMembershipCtaDisabled(link, true);
    });
  }

  function updateMembershipCtas(variant, sectionId, variantWasProvided) {
    forEachMembershipCta(sectionId, function (link) {
      var baseUrl = link.dataset.baseUrl;
      if (!baseUrl) return;

      var variantIsAvailable = variantWasProvided
        ? Boolean(variant && variant.available)
        : link.dataset.variantAvailable === 'true';
      var variantId = variant && variant.id ? variant.id : link.dataset.variantId;

      if (!variantIsAvailable || !variantId) {
        setMembershipCtaDisabled(link, true);
        return;
      }

      try {
        var url = new URL(baseUrl, window.location.origin);
        if (link.dataset.productId) url.searchParams.set('productId', link.dataset.productId);
        url.searchParams.set('variantId', variantId);
        link.dataset.variantId = variantId;
        link.dataset.variantAvailable = 'true';
        link.href = url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.href;
        setMembershipCtaDisabled(link, false);
      } catch (error) {
        setMembershipCtaDisabled(link, true);
      }
    });
  }

  function initMembershipCtas(sectionId) {
    updateMembershipCtas(null, sectionId, false);
  }

  onReady(function () {
    initLoginReturnLinks();
    initMembershipModals();
    initDetailsToggles();
    initActionForms();
    initMembershipCheckoutForms();
    initMembershipCtas();

    document.addEventListener('product-info:loaded', function (event) {
      initMembershipCtas(event.target && event.target.dataset ? event.target.dataset.section : null);
    });
    document.addEventListener('change', function (event) {
      var variantSelects = event.target.closest('variant-selects');
      if (variantSelects) disableMembershipCtas(variantSelects.dataset.section);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data ? event.data : {};
        updateMembershipCtas(data.variant || null, data.sectionId || null, true);
      });
    }
  });
})();
